const featuresPay = {
    featureTitle: 'Magdesisyon sa Negosyo Batay sa Data',
    featureDescription:
        'Malaman kung aling mga item ang pinakamabenta at nagbibigay ng pinakamataas na kita, at i-access ang mga financial report anumang oras, kahit saan. Ang iyong negosyo nasa kamay mo!',
    featureButton: "Premium Subscription",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'Simula sa',
    featureEndingText: 'Libo',

    features: [
        {
            title: 'Walang Limitasyong Items',
            description: 'Magdagdag ng lahat ng items na pag-aari mo nang walang limitasyon.'
        },
        {
            title: 'Walang Limitasyong Staff',
            description: 'Magdagdag ng Staff/Admin sa negosyo nang walang limitasyon.'
        },
        {
            title: 'Walang Limitasyong History',
            description: 'Tingnan ang mga pagbabago sa lumang stock records nang walang limitasyon.'
        },
        {
            title: 'History Filter',
            description: 'Madaling tingnan ang history batay sa uri, kategorya, staff, at petsa.'
        },
        {
            title: 'I-download sa Excel',
            description: 'Kunin ang stock record history sa Microsoft Excel sa isang click lang.'
        },
        {
            title: 'I-download sa PDF',
            description: 'Kunin ang pinakabagong listahan ng items at stock sa PDF sa isang click lang.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Gumawa ng maraming warehouse para sa mas magandang pamamahala ng stock.'
        },
        {
            desc: 'Magtalaga ng mga produkto sa partikular na lokasyon.'
        },
        {
            desc: 'Subaybayan ang antas ng inventory sa iba\'t ibang warehouse.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Magdagdag ng size, kulay, o material variants.' },
        { desc: 'Magtakda ng stock levels bawat variant.' },
        { desc: 'Subaybayan sa iba\'t ibang warehouse.' }
    ]
}
export default featuresPay